/**
 * Converts a strip's grid position into its flat index in the strip list. Takes the row from position.x and the column from position.y, then adds the column to the row multiplied by the strips-per-row count.
 *
 * @param position - The strip's grid coordinates, x being the row and y the column.
 * @param stripPerRow - How many strips a grid row holds.
 * @returns The flat index of the strip.
 */
export const getStripIndex = (position: { x: number; y: number }, stripPerRow: number) => {
  const { x: row, y: column } = position;
  return column + row * stripPerRow;
};

/**
 * Converts a flat strip index into its row and column in the strip grid. Floor-divides by the strips-per-row count for the row and takes the remainder for the column, short-circuiting to the origin when the index is zero.
 *
 * @param index - The strip's flat index in the strip list.
 * @param stripPerRow - How many strips a grid row holds.
 * @returns An object carrying x as the row and y as the column.
 */
export const getStripPosition = (index: number, stripPerRow: number) => {
  if (index) {
    const row = Math.floor(index / stripPerRow);
    const column = index % stripPerRow;
    return { x: row, y: column };
  }
  return { x: 0, y: 0 };
};

export const eventOffsetPreviewStrip = [1000, 4000];
export const bookmarkOffsetPreviewStrip = [2500, 2500];
